import { Controller } from "stimulus";
import AjaxLoader from "../entrypoints/src/admin/utilities/ajax-loader";
import forwardTo from "../entrypoints/src/admin/utilities/window-navigation";

export default class extends Controller {
  connect() {
    this.element.querySelectorAll('[data-href]').forEach((el) => {
      el.addEventListener('click', () => {
        AjaxLoader.show();

        forwardTo(el.dataset.href);
      });
    })
  }
};
